import { useTranslation } from '../../../hooks/useTranslation';
import Badge from '../../badge/Badge';
import './ProductDiscountBadge.less';

export type ProductDiscountBadgeProps = {
    mode: 'text' | 'percentage';
    className?: string;
    percentage: number;
    digits?: number;
};

const ProductDiscountBadge = ({
    mode,
    className = '',
    percentage,
    digits = 0
}: ProductDiscountBadgeProps) => {
    const { t } = useTranslation();
    return (
        <Badge className={`bri-ProductDiscountBadge ${className}`}>
            {mode === 'percentage'
                ? Number(-percentage / 100).toLocaleString(undefined, {
                      style: 'percent',
                      minimumFractionDigits: digits
                  })
                : t('PRODUCT_DEAL_BADGE')}
        </Badge>
    );
};

export default ProductDiscountBadge;
